import { I18nUtil } from "@utils/i18n";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import React from "react";
import Translations from "@translate/components/TokenDetails/SocialSentiment";
import { cn } from "utils";

const I18n = I18nUtil.createScoped(Translations);

interface SocialSentimentProps {
  className?: string;
  percentage: number;
}

const SocialSentiment: React.FC<SocialSentimentProps> = ({
  className,
  percentage,
}) => {
  const bullishPercentage = percentage;
  const bearishPercentage = 100 - percentage;

  return (
    <div className={cn("w-full", className)}>
      <h2
        aria-label="Social Sentiment h2"
        data-openreplay-label="Social Sentiment h2 Semantic"
        id="sem-social-sentiment-h2"
        className="headline_regular_s mb-4 text-content_primary"
      >
        {I18n.t("Social Hype")}
      </h2>
      <div className="flex flex-col gap-2">
        {/* 标签和百分比 */}
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-1 text-content_accent1_primary body_medium_m">
            <OspIcons name="ic_rise" size={16} color="#02D79B" />
            <span>{I18n.t("Bullish")}</span>
            <span>{bullishPercentage}%</span>
          </div>
          <div className="flex items-center gap-1 text-content_accent2_primary body_medium_m">
            <OspIcons name="ic_fall" size={16} color="#FF7375" />
            <span>{I18n.t("Bearish")}</span>
            <span>{bearishPercentage}%</span>
          </div>
        </div>

        {/* 进度条 */}
        <div className="flex w-full" style={{ gap: "4px" }}>
          {/* Bullish 进度条 */}
          {bullishPercentage > 0 && (
            <div
              className="bg-background_accent1_overlay70 rounded-[2px]"
              style={{
                width: `${bullishPercentage}%`,
                height: "8px",
              }}
            />
          )}
          {/* Bearish 进度条 */}
          {bearishPercentage > 0 && (
            <div
              className="bg-background_accent2_overlay70 rounded-[2px]"
              style={{
                width: `${bearishPercentage}%`,
                height: "8px",
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export { SocialSentiment };
export type { SocialSentimentProps };
